import { FilterArrayType } from 'common/components/Filters';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import { BatchTransactionsOrderBy } from 'common/types/globalTypes';

type OrderLookup = {
  [direction in OrderDirection]: BatchTransactionsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'weekNumber',
    {
      [OrderDirection.ASC]: ['WEEK_NUMBER_ASC'],
      [OrderDirection.DESC]: ['WEEK_NUMBER_DESC'],
    },
  ],
  [
    'referenceNumber',
    {
      [OrderDirection.ASC]: ['REFERENCE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['REFERENCE_NUMBER_DESC'],
    },
  ],
  [
    'postingDate',
    {
      [OrderDirection.ASC]: ['POSTING_DATE_ASC'],
      [OrderDirection.DESC]: ['POSTING_DATE_DESC'],
    },
  ],
  [
    '_periodYear',
    {
      [OrderDirection.ASC]: ['CORPORATE_PERIOD_ID_ASC'],
      [OrderDirection.DESC]: [
        'CORPORATE_PERIOD_ID_DESC',
      ],
    },
  ],
  [
    'currencyData',
    {
      [OrderDirection.ASC]: ['CURRENCY_ID_ASC'],
      [OrderDirection.DESC]: ['CURRENCY_ID_DESC'],
    },
  ],
  [
    'controlTotalAmount',
    {
      [OrderDirection.ASC]: ['CONTROL_TOTAL_AMOUNT_ASC'],
      [OrderDirection.DESC]: [
        'CONTROL_TOTAL_AMOUNT_DESC',
      ],
    },
  ],
  [
    '_batchTransactionTotal',
    {
      [OrderDirection.ASC]: [
        '_BATCH_TRANSACTION_TOTAL_ASC',
      ],
      [OrderDirection.DESC]: [
        '_BATCH_TRANSACTION_TOTAL_DESC',
      ],
    },
  ],
  [
    '_batchTransactionCount',
    {
      [OrderDirection.ASC]: [
        '_BATCH_TRANSACTION_COUNT_ASC',
      ],
      [OrderDirection.DESC]: [
        '_BATCH_TRANSACTION_COUNT_DESC',
      ],
    },
  ],
  [
    'status',
    {
      [OrderDirection.ASC]: [
        'STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_DESC',
      ],
    },
  ],
  [
    '_createdByUserid',
    {
      [OrderDirection.ASC]: [
        '_CREATED_BY_USER_NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        '_CREATED_BY_USER_NAME_DESC',
      ],
    },
  ],
]);

export const toOrderByVariable = (
  sort?: SortOrder
): BatchTransactionsOrderBy[] => {
  const orderByArray: BatchTransactionsOrderBy[] = [
    'REFERENCE_NUMBER_ASC',
    'PRIMARY_KEY_ASC',
  ];

  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ?? []), 'PRIMARY_KEY_ASC'];
};


export const toFilterVariable = (filterList: FilterArrayType[]) =>
  filterList.map((filter) => {
    switch (filter.filterKey) {
      case 'currencyId':
      case 'weekNumber':
      case '_statusTypeId':
      case '_createdByUserid':
      case 'corporatePeriodId':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };
      default:
        return undefined;
    }
  });
